import React from 'react';

/**
 * Common progress bar component for activities
 * @param {Object} props - Component props
 * @param {number} props.current - Current question number
 * @param {number} props.total - Total number of questions
 * @param {number} props.progress - Progress percentage (0-100)
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element} Progress component
 */
const ActivityProgress = ({
  current,
  total,
  progress,
  className = ''
}) => {
  return (
    <div className={`activity-progress ${className}`}>
      <div className="progress-bar-container">
        <div className="progress-bar-bg">
          <div
            className="progress-bar-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
      <div className="progress-info">
        <span className="current-question">{current}</span>
        <span className="separator">/</span>
        <span className="total-questions">{total}</span>
      </div>
    </div>
  );
};

export default ActivityProgress;
